import styled from 'styled-components';

import { CONTAINER_MAX } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const BodyWrapper = styled.div<{ $isBack?: boolean }>`
  width: 100%;
  flex: 1;
  ${flexColumn};
  gap: 15px;
  padding: 0 40px 24px;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    gap: 10px;
    padding-inline: var(--px-mobile);
    padding-bottom: calc(
      env(safe-area-inset-bottom) +
        ${({ $isBack }) => ($isBack ? '122px' : '89px')}
    );
  }

  @media (max-width: ${CONTAINER_MAX.mobileM}) {
    padding-inline: var(--px-mobile-s);
  }
`;
